import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export class SearchResultsMessage extends React.Component {
  constructor(props) {
    super(props);

    let { termsLength, displayMessage } = props;
  }


  render() {
    const { termsLength, displayMessage } = this.props;
    const label = displayMessage ? "Showing results for the first 50 words." : null;

    return (
      <div 
        className="search__results_msg">
        { label }
      </div>
    );
  }
}

export default SearchResultsMessage;

const { string, bool } = PropTypes;

SearchResultsMessage.propTypes= {
  termsLength: string,
  displayMessage: bool
};
